/* MA LICENCES — bouton de chat : couleur vive, pulsation discrete, remontee
   au-dessus de la barre d'achat collante, et effacement complet quand un
   panneau est ouvert par-dessus la page (tiroir de panier, menu mobile,
   recherche). Sans cela le bouton recouvre « Commander » dans le tiroir. */
(function () {
  var STICKY = '.sticky-add-to-cart__content';
  var BASE = 88;
  var GAP = 16;

  var css = [
    '.activator{background:linear-gradient(135deg,#2f74d0 0%,#1d5fbf 55%,#164a96 100%)!important;',
    'color:#fff!important;border:none!important;box-shadow:0 6px 20px rgba(29,95,191,.45)!important;',
    'animation:mlChatPulse 6s ease-in-out infinite}',
    '.activator:hover{filter:brightness(1.07)}',
    '.activator__icon,.activator__icon svg,.activator__icon path{color:#fff!important;opacity:1!important}',
    '.activator__label{color:#fff!important;font-weight:700!important}',
    '.activator__indicator{background:#fff!important}',
    '.activator-nudge{bottom:var(--ml-chat-bottom,88px)!important;',
    'opacity:var(--ml-chat-op,1)!important;',
    'pointer-events:var(--ml-chat-pe,auto)!important;',
    'transition:bottom .28s ease,opacity .18s ease}',
    '@keyframes mlChatPulse{',
    '0%,70%,100%{transform:scale(1);box-shadow:0 6px 20px rgba(29,95,191,.45)}',
    '75%{transform:scale(1.08) rotate(-3deg);box-shadow:0 10px 28px rgba(29,95,191,.6)}',
    '80%{transform:scale(1.08) rotate(3deg)}',
    '85%{transform:scale(1.05) rotate(-2deg)}',
    '90%{transform:scale(1.02) rotate(0deg)}}',
    '@media (prefers-reduced-motion:reduce){.activator{animation:none!important}}'
  ].join('');

  /* Depuis octobre 2026, Shopify place le bouton dans une seconde racine
     fantome (shopify-agent-runtime) : on pose le style a chaque niveau. */
  function injecte(host) {
    var sr = host.shadowRoot;
    if (!sr) return;
    if (!sr.querySelector('style[data-ml-chat]')) {
      var st = document.createElement('style');
      st.setAttribute('data-ml-chat', '');
      st.textContent = css;
      sr.appendChild(st);
    }
    var inner = sr.querySelectorAll('*');
    for (var i = 0; i < inner.length; i++) {
      if (inner[i].shadowRoot) injecte(inner[i]);
    }
  }

  function visible(el) {
    if (!el || !el.isConnected) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity) < 0.05) return false;
    var r = el.getBoundingClientRect();
    /* Safari iOS (barre d'adresse flottante en bas) : la barre d'achat s'arrete
       au-dessus de la barre Safari, donc bien avant le bas de innerHeight.
       On la considere visible des qu'elle occupe le bas de l'ecran. */
    var h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    return r.height > 0 && r.top < h && r.bottom > h - 220;
  }

  /* Un panneau recouvre la page : le theme pose 'overflow-hidden' sur le body
     quand le tiroir de panier, le menu mobile ou la recherche s'ouvrent. On
     tient aussi compte des <dialog open> reellement affiches. */
  function panneauOuvert() {
    if (document.body.classList.contains('overflow-hidden')) return true;
    var dlgs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dlgs.length; i++) {
      var r = dlgs[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }

  function ajuste(host) {
    if (panneauOuvert()) {
      host.style.setProperty('--ml-chat-op', '0');
      host.style.setProperty('--ml-chat-pe', 'none');
      return;
    }
    host.style.setProperty('--ml-chat-op', '1');
    host.style.setProperty('--ml-chat-pe', 'auto');

    var bar = document.querySelector(STICKY);
    var v = BASE;
    if (visible(bar)) v = Math.max(Math.round(window.innerHeight - bar.getBoundingClientRect().top), Math.round(bar.getBoundingClientRect().height)) + GAP;
    host.style.setProperty('--ml-chat-bottom', v + 'px');
  }

  function demarre(host) {
    injecte(host);
    ajuste(host);
    var t = null;
    var maj = function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () { injecte(host); ajuste(host); }, 60);
    };
    window.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    document.addEventListener('cart:updated', maj);
    if (window.MutationObserver) {
      new MutationObserver(maj).observe(document.body, {
        attributes: true, subtree: true, attributeFilter: ['class', 'style', 'open']
      });
    }
  }

  var essais = 0;
  var it = setInterval(function () {
    var host = document.querySelector('shopify-chat');
    if (host && host.shadowRoot) { clearInterval(it); demarre(host); }
    else if (++essais > 80) { clearInterval(it); }
  }, 500);
})();
